import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import {DataTableModule} from 'angular2-datatable';
import {ExcelService} from '../common/API/excel.service';
import { NotifierModule } from 'angular-notifier';
import { UploadPriceComponent } from './uploadprices.component';
import { ApiService } from '../common/API/api.service';
import {BackRestrict} from '../common/backRestrict'
import { FormsModule } from '@angular/forms';
import { MatInputModule, MatPaginatorModule, MatProgressSpinnerModule,
  MatSortModule, MatTableModule } from '@angular/material';

const routerConfig = [{
  path: '',
  component: UploadPriceComponent
}];

@NgModule({
  imports: [
    CommonModule,FormsModule ,
    MatTableModule ,MatSortModule,MatInputModule, MatPaginatorModule, MatProgressSpinnerModule,
    
    RouterModule.forChild(routerConfig),
    ReactiveFormsModule,DataTableModule,
    NotifierModule.withConfig({
      position: {
        horizontal: {
          position: 'right',
          distance: 12
        },
        vertical: {
          position: 'top',
          distance: 12,
          gap: 10
        }
      },
      theme: 'material',
      behaviour: {
        autoHide: 3000,
        onClick: false,
        onMouseover: 'pauseAutoHide',
        showDismissButton: false,
        stacking: 1
      },
      animations: {
        enabled: true,
        show: {
          preset: 'slide',
          speed: 200,
          easing: 'ease'
        },
        hide: {
          preset: 'fade',
          speed: 300,
          easing: 'ease',
          offset: 50
        },
        shift: {
          speed: 300,
          easing: 'ease'
        },
        overlap: 150
      }
    })
  ],
  declarations: [
    UploadPriceComponent
  ],
  exports: [
    UploadPriceComponent
  ],
  providers: [
    ApiService,
    ExcelService ,
    BackRestrict
  ]
})

export class UploadPriceModule { }




